export const assertUnreachable = (input: never): never => {
    throw new Error(
        `Invalid value - this element of code shouldn't be reachable (probably used as "default:" value of switch) - value: ${input}`,
    );
};
